export default {
  steps: {
    discount: 'Sconto',
    mobile_app: 'App mobile',
    business_info: 'Dati aziendali',
    create_preview: 'Crea contratto di anteprima',
    preview: 'Anteprima contratto',
    sign: 'Firma contratto',
  },
  buttons: {
    back: 'Indietro',
    continue: 'Continua',
  },
  agreement:
    "Il passaggio all'annuale applica lo sconto del {{discount}}% al tuo piano {{plan}}. La fatturazione continua mensilmente a {{amount}} al mese con un impegno di {{months}} mesi.",
  toasts: {
    failed_to_save_changes: 'Impossibile salvare le modifiche',
    failed_to_switch: "Impossibile passare all'annuale",
    switched_to_annual: "Contratto passato all'annuale 👌",
  },
};
